import React, { useState, useEffect } from 'react';
import { useParams, withRouter } from 'react-router-dom';
import { Typography, Spin, Menu } from 'antd';
import ActionHeader from '../Common/ActionHeader';
import UnitOfferAdd from '../unitOffer/UnitOfferAdd';
import UnitOffersAdd from '../unitOffer/UnitOffersAdd';
import UnitOfferTable from '../unitOffer/UnitOfferTable';
import { getUnitOffers } from '../../services/unitOfferService';
import EditableUnitOfferTable from '../../pages/CloneCourseOfferPage/components/EditableUnitOfferTable';

const { Text, Title } = Typography;

const UnitOfferSection = ({ cloning, courseOffer }) => {
  const { id } = useParams();
  const [unitOffers, setUnitOffers] = useState([]);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isAddMultipleModalOpen, setIsAddMultipleModalOpen] = useState(
    false
  );
  const [isLoading, setIsLoading] = useState(true);
  const [status, setStatus] = useState({
    error: false,
    message: ''
  });
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    fetchData();
  }, [id]);

  const fetchData = async () => {
    setIsLoading(true);

    await getUnitOffers(0, 0, { courseOfferId: id })
      .then((response) => {
        const offers = response.data.unitOffers;
        setUnitOffers(offers);
        setTotalCount(offers.length);
      })
      .catch((err) => {
        setStatus({
          error: true,
          message: `${err}`
        });
      });

    setIsLoading(false);
  };

  const actionMenu = (
    <Menu>
      <Menu.Item onClick={() => setIsAddModalOpen(true)}>
        Add Unit Offer
      </Menu.Item>
      <Menu.Item onClick={() => setIsAddMultipleModalOpen(true)}>
        Add Unit Offers
      </Menu.Item>
    </Menu>
  );

  return (
    <>
      <div
        style={{
          paddingBottom: '10px'
        }}>
        <Text
          style={{
            float: 'left',
            position: 'relative'
          }}>
          Total Unit Offer:{' '}
          <strong style={{ fontSize: '20px' }}>{totalCount}</strong>{' '}
          records
        </Text>
        {!cloning && <ActionHeader actionMenu={actionMenu} />}
      </div>

      <UnitOfferAdd
        isOpen={isAddModalOpen}
        toggle={() => setIsAddModalOpen((prev) => !prev)}
      />
      <UnitOffersAdd
        isOpen={isAddMultipleModalOpen}
        toggle={() => setIsAddMultipleModalOpen((prev) => !prev)}
      />
      {isLoading ? (
        <div
          style={{
            textAlign: 'center',
            marginTop: '50px'
          }}>
          <Spin />
        </div>
      ) : status.error ? (
        <div style={{ marginTop: '50px', textAlign: 'center' }}>
          <Title>{status.message}</Title>
        </div>
      ) : cloning ? (
        <EditableUnitOfferTable
          unitOffers={unitOffers}
          setTotalCount={setTotalCount}
          courseOffer={courseOffer}
        />
      ) : (
        <UnitOfferTable data={unitOffers} />
      )}
    </>
  );
};

export default withRouter(UnitOfferSection);
